import { Heading } from "@ariakit/react";
import { ReactNode } from "react";
import { atomic } from "../atomic.css";

export function SubtleHeading(props: { children: ReactNode }) {
  return (
    <Heading
      className={atomic({
        paddingBlockEnd: 6,
        fontSize: 14,
        fontWeight: "medium",
      })}
    >
      {props.children}
    </Heading>
  );
}
